import React, { useState } from 'react'

import { Box, Flex, Icon, InlineButton, Link, Text, Tooltip } from '@driftt/dds'
import { faCodeBranch } from '@driftt/dds.icons/light/faCodeBranch'

import { TruncatedText } from 'components/TruncatedText'

interface PageViewContentProps {
  pages: { url?: string; title?: string }[]
  referrer?: string
  trackAction: (action: string, additionalData?: any) => void
}

export const PageViewContent = ({ pages, referrer, trackAction }: PageViewContentProps) => {
  const [expanded, setExpanded] = useState(false)

  return (
    <Flex direction="column" css={{ paddingTop: '16px' }} gap={0}>
      {pages.slice(0, expanded ? pages.length : 2).map((page, index) => (
        <Link
          key={index}
          href={page.url}
          target="_blank"
          truncate
          css={{ color: '$gray12', textDecoration: 'underline' }}>
          {page.title}
        </Link>
      ))}
      {pages.length > 2 && !expanded && (
        <InlineButton
          onClick={() => {
            setExpanded(true)
            trackAction('Expand page views list')
          }}
          css={{ color: '$gray12', fontWeight: 400, padding: 0 }}>{`+${pages.length -
          2} more`}</InlineButton>
      )}
      {referrer && (
        <Box css={{ paddingTop: '16px' }}>
          <Tooltip side="right" content={<TruncatedText content={`Referred by ${referrer}`} />}>
            <Link href={referrer} target="_blank" css={{ color: '$gray12' }}>
              <Flex alignItems="center">
                <Icon icon={faCodeBranch} color="gray12" />
                <Text css={{ maxWidth: '220px' }} truncate>
                  {referrer}
                </Text>
              </Flex>
            </Link>
          </Tooltip>
        </Box>
      )}
    </Flex>
  )
}
